import { render, staticRenderFns } from "./OrderMaterial.vue?vue&type=template&id=7c48b2c4&scoped=true&"
import script from "./OrderMaterial.vue?vue&type=script&lang=js&"
export * from "./OrderMaterial.vue?vue&type=script&lang=js&"
import style0 from "./OrderMaterial.vue?vue&type=style&index=0&id=7c48b2c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c48b2c4",
  null
  
)

export default component.exports